<template>
    <div id="ap">
        <a-layout>
            <div class="content-header">
                <a-affix :offset-top="0" style="width: 100%;">
                    <a-row type="flex" justify="space-between">
                        <a-col span="12">
                            <common-page-btn></common-page-btn>
                        </a-col>
                        <a-col span="12">
                            <a-row type="flex" justify="end" :gutter="3">
                                <a-col span="6">
                                    <a-input v-model="param.keyword" allowClear search @pressEnter="doRefresh"
                                        @on-clear="doRefresh" placeholder="关键词查询"></a-input>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-affix>
            </div>
        </a-layout>

        <a-layout>
            <a-layout-content>
                <a-table :defaultExpandAllRows="true" :scroll="{ x: '100%' }" :pagination="false" :indentSize="25"
                    :style="{ background: '#FFF' }" size="small" row-key="userId" :columns="keys" ref="list"
                    :loading="loading" :data-source="data.records">
                    <template slot-scope="row" slot="user">
                        <a-space>
                            <a-avatar :src="row.avatar" size="small"></a-avatar>
                            <a>{{ row.nickName }}</a>
                        </a-space>
                    </template>
                    <template slot-scope="row" slot="phone">
                        <a-space>
                            <show-phone :phone="row.phone"></show-phone>
                        </a-space>
                    </template>
                    <template slot-scope="row" slot="merchant">
                        <template v-if="row.storeId > 0">{{ row.storeName }}</template>
                        <template v-else>-</template>
                    </template>
                    <template slot-scope="row" slot="staff">
                        <template v-if="row.staffId > 0">{{ row.staffName }}</template>
                        <template v-else>-</template>
                    </template>
                    <template slot-scope="row" slot="status">
                        <a-tag v-if="row.status == 1" color="green" @click="doStatus(row, 0)">启用</a-tag>
                        <a-tag v-else color="red" @click="doStatus(row, 1)">停用</a-tag>
                    </template>
                    <template slot-scope="row" slot="action">
                        <a-tooltip title="编辑" v-has="'user:update'">
                            <a-button type="link" icon="edit" @click="$refs.userFormRef.show(row)"></a-button>
                        </a-tooltip>
                    </template>
                </a-table>
            </a-layout-content>
        </a-layout>
        <a-row>
            <a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
                <a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
                    @showSizeChange="setLimit" :current="data.current" />
            </a-col>
        </a-row>
        <a-back-top />
        <user-form ref="userFormRef" @success="doRefresh"></user-form>
    </div>
</template>

<script>
import apiUtil from "@/common/apiUtil";
import utils from '@/common/utils';
import userForm from "./components/user-form.vue";
export default {
    components: { userForm },
    data() {
        return {
            data: [],
            loading: false,
            param: {
                page: 1,
                limit: 20,
                keyword: '',
            },
            organList: apiUtil.getOrganList(),
            keys: [
                { title: '用户', scopedSlots: { customRender: 'user' }, ellipsis: true },
                { title: '手机号', scopedSlots: { customRender: 'phone' }, width: 180, align: 'center', ellipsis: true },
                { title: '积分', dataIndex: 'grade', width: 120, align: 'center', ellipsis: true },
                { title: '绑定商户', scopedSlots: { customRender: 'merchant' }, width: 220, ellipsis: true },
                { title: '绑定员工', scopedSlots: { customRender: 'staff' }, width: 120, ellipsis: true },
                // { title: '创建日期', dataIndex: 'createDate', width: 140, ellipsis: true },
                { title: '状态', scopedSlots: { customRender: 'status' }, width: 120, ellipsis: true },
                { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 200 }
            ],
        };
    },
    created() {
        this.doRefresh();
    },
    methods: {
        doStatus(row, status) {
            utils.confirm('确定要修改状态吗？').then(() => {
                this.http.post('/platform/user/update', { userId: row.userId, status: status }).then(ret => {
                    utils.success('修改成功').then(() => {
                        this.doRefresh();
                    })
                });
            })
        },
        // 获取数据
        getList() {
            this.loading = true;
            this.http
                .get('/platform/user/list', this.param)
                .then(ret => {
                    this.data = ret.data;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                });
        },
        doRefresh() {
            this.param.page = 1;
            this.getList();
        },
        //设置每页的显示条数
        setLimit(current, limit) {
            this.param.page = 1;
            this.param.limit = limit;
        },
        //页码切换
        getNext(page) {
            this.param.page = page;
            this.getList();
        }
    }
};
</script>

<style scoped></style>
